export const bootstrap = async () => {
  window._ = {}

  require('./globals/lodash')
  require('./globals/array')
  require('./globals/object')
}
